import { Button } from "antd";
import { Can } from "@/shared/lib/casl";
import "./section-first-actions.scss";

interface SectionFirstActionsProps {
  canSend: boolean;
  canReject: boolean;
  canRollback: boolean;
  canDelete: boolean;
  canVersions: boolean;
  canEdit: boolean;
  handleSend: () => void;
  handleRecall: () => void;
  handleRollback: () => void;
  handleDelete: () => void;
  setHistoryOpen: (value: boolean) => void;
  handleEditClick: () => void;
  handleClose: () => void;
}

export const SectionFirstActions = ({
  canSend,
  canReject,
  canRollback,
  canDelete,
  canVersions,
  canEdit,
  handleSend,
  handleRecall,
  handleRollback,
  handleDelete,
  setHistoryOpen,
  handleEditClick,
  handleClose,
}: SectionFirstActionsProps) => {
  return (
    <div className="section-first-actions">
      {canSend && (
        <Can I="edit" a="section_1">
          <Button onClick={handleSend} style={{ height: 44 }}>
            Отправить на подписание
          </Button>
        </Can>
      )}
      {canReject && (
        <Can I="edit" a="section_1">
          <Button onClick={handleRecall} style={{ height: 44 }}>
            Отозвать с подписания
          </Button>
        </Can>
      )}
      {canRollback && (
        <Can I="edit" a="section_1">
          <Button onClick={handleRollback} style={{ height: 44 }}>
            Вернуть в работу
          </Button>
        </Can>
      )}
      {canDelete && (
        <Can I="edit" a="section_1">
          <Button onClick={handleDelete} style={{ height: 44 }}>
            Удалить
          </Button>
        </Can>
      )}
      {canVersions && (
        <Button
          onClick={() => setHistoryOpen(true)}
          style={{ height: 44 }}
        >
          Версии
        </Button>
      )}
      {canEdit && (
        <Can I="edit" a="section_1">
          <Button onClick={handleEditClick} style={{ height: 44 }}>
            Редактировать
          </Button>
        </Can>
      )}
      <Button
        onClick={handleClose}
        style={{ height: 44 }}
        type="primary"
      >
        Закрыть
      </Button>
    </div>
  );
};

